import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MenuVariaveis from '../../../MenuVariaveis';
import iconAdd from '../../../../assets/images/icon_add_blue.svg';
import CustomItensRequestList from './CustomItenRequestList';

export default (props) => {
  const { doUpdateItem, item, answerHandlerOpen } = props;

  const [GlpiSettings, setGlpiSettings] = useState({
    login: '',
    password: '',
    quantity: '',
    status: '',
    header: '',
    customList: [],
  });

  const [customList, setCustomList] = useState(item.glpi?.customList || []);

  useEffect(() => {
    if (item && item.glpi) {
      setGlpiSettings(item.glpi);
    }
  }, [item]);

  const { i18n } = useTranslation();

  const handleInputSettingsChange = (e) => {
    const { name, value } = e.target;
    const updatedSettings = { ...GlpiSettings, [name]: value };

    setGlpiSettings(updatedSettings);
    doUpdateItem({ glpi: updatedSettings });
  };

  const handleAddKeyValue = () => {
    const valor = { key: '', value: '' };

    setCustomList(customList.concat(valor));
  };

  const changeKey = (index, e) => {
    customList[index].key = e.target.value;

    setCustomList(customList);

    const obj = { target: { name: 'customList', value: customList } };

    handleInputSettingsChange(obj);
  };

  const changeValue = (index, option) => {
    customList[index].value = option;
    setCustomList(customList);

    const obj = { target: { name: 'customList', value: customList } };

    handleInputSettingsChange(obj);
  };

  const deleteKeyValue = async (keyValue) => {
    const newArray = await customList.filter((element) => element !== keyValue);

    setCustomList(newArray);

    const obj = { target: { name: 'customList', value: newArray } };

    handleInputSettingsChange(obj);
  };

  const handleSelectVariavel = (name, value, variavel) => {
    const newValue = `${value}${variavel}`;
    const updatedSettings = { ...GlpiSettings, [name]: newValue };

    setGlpiSettings(updatedSettings);
    doUpdateItem({ glpi: updatedSettings });
  };

  return (
    <>
      <p className="handler-title">Listar Tickets</p>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('login', GlpiSettings.login, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-login`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Login')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.login || ''}
            name="login"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'password',
            GlpiSettings.password,
            `{${variavel}}`
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-password`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Senha')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.password || ''}
            name="password"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'quantity',
            GlpiSettings.quantity,
            `{${variavel}}`
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-quantity`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Quantidade')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.quantity || ''}
            name="quantity"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('status', GlpiSettings.status, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-status`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>
            {i18n.t('Filtro de Status')}
            <img
              className="img-info"
              alt="?"
              src="/static/media/ponto-interrogacao.9ac9cab0.svg"
            />
            <div className="tooltip-text">
              Valores aceitos: <br />
              1, 2, 3, 4, 5 e 6
            </div>
          </label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.status || ''}
            name="status"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('header', GlpiSettings.header, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-header`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Cabeçalho da Lista')}</label>
          <input
            className="form-control mt-1"
            value={GlpiSettings.header || ''}
            name="header"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      {/* { Listagem Customizada} */}
      <div className="header-customizado-api">
        <div className="header-title-customizado">
          <label>{i18n.t('Adicionar Padrão de Listagem')}</label>
          <img src={iconAdd} alt="" onClick={handleAddKeyValue} />
        </div>
        {customList.map((row, index) => (
          <CustomItensRequestList
            item={customList[index]}
            row={row}
            index={index}
            answerHandlerOpen={answerHandlerOpen}
            deleteKeyValue={deleteKeyValue}
            changeKey={changeKey}
            changeValue={changeValue}
          />
        ))}
      </div>

      <div className="common-form-group">
        <label>Acesse a variável para a lista de Tickets</label>
        <input
          className="form-control mt-1"
          defaultValue="{glpi.request_list}"
          disabled
        />
      </div>
    </>
  );
};
